export class FreeSpinsEvents {
	public static readonly FREE_SPINS_INTRO_STARTED: string = 'FreeSpinsEvents::FREE_SPINS_INTRO_STARTED';
	public static readonly FREE_SPINS_RESTORE_INTRO_STARTED: string = 'FreeSpinsEvents::FREE_SPINS_RESTORE_INTRO_STARTED';
	public static readonly FREE_SPINS_OUTRO_STARTED: string = 'FreeSpinsEvents::FREE_SPINS_OUTRO_STARTED';

	public static readonly FREE_SPINS_START_READY: string = 'FreeSpinsEvents::FREE_SPINS_START_READY';

	public static readonly FREE_SPINS_INTRO_FINISHED: string = 'FreeSpinsEvents::FREE_SPINS_INTRO_FINISHED';
	public static readonly FREE_SPINS_OUTRO_FINISHED: string = 'FreeSpinsEvents::FREE_SPINS_OUTRO_FINISHED';

	public static readonly SHOWING_WIN_SUMMARY_SCREEN: string = 'FreeSpinsEvents::SHOWING_WIN_SUMMARY_SCREEN';

	public static readonly FREE_SPINS_CONTINUE_CLICKED: string = 'FreeSpinsEvents::FREE_SPINS_CONTINUE_CLICKED';
	public static readonly FREE_SPINS_OUTRO_CONTINUE_CLICKED: string = 'FreeSpinsEvents::FREE_SPINS_OUTRO_CONTINUE_CLICKED';
	public static readonly FREE_SPINS_RETRIGGER_STARTED: string = 'FreeSpinsEvents::FREE_SPINS_RETRIGGER_STARTED';
	public static readonly FREE_SPINS_RETRIGGER_FINISHED: string = 'FreeSpinsEvents::FREE_SPINS_RETRIGGER_FINISHED';

	public static readonly FREE_SPIN_STARTED: string = 'FreeSpinsEvents::FREE_SPIN_STARTED';

	public static readonly FREE_SPINS_INTRO_JINGLE_FINISHED: string = 'FreeSpinsEvents::FREE_SPINS_INTRO_JINGLE_FINISHED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents.ts